import { render } from "./CommentReplyForm.vue?vue&type=template&id=1bef7823"
import script from "./CommentReplyForm.vue?vue&type=script&lang=js"
export * from "./CommentReplyForm.vue?vue&type=script&lang=js"

import "./CommentReplyForm.vue?vue&type=style&index=0&id=1bef7823&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__